import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { Suspense, useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { I18nProvider } from './_metronic/i18n/i18nProvider';
import { LayoutProvider, LayoutSplashScreen } from './_metronic/layout/core';
import './global.css';
import fetchPermission from './permissions/fetch-permission';
import PermissionProvider from './permissions/permission-provider';
import { Routes } from './router/Routes';
import { useAppSelector } from './services/redux/app/Store';
import { UserModel } from './services/redux/slices/auth/models/UserModel';

type Props = {
  basename: string;
};

const queryClient = new QueryClient();

const App: React.FC<Props> = ({ basename }) => {
  const { user }: UserModel | any = useAppSelector((state) => state.auth);

  useEffect(() => {
    const tagManagerArgs = {
      gtmId: 'GTM-5N6JSXJJ',
      dataLayer: {
        vendorId: user?.vendor?.id, 
      },
    };
    TagManager.initialize(tagManagerArgs);

    const script = document.createElement('script');
    script.src = 'https://statics.idefix.com/mpstatics/tracking.js?version=1';
    script.async = true;
    script.onload = () => {
      console.log('Script loaded successfully');
    };
    script.onerror = () => {
      console.error('Script failed to load');
    };
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [user?.vendor?.id]);
  return (
    <PermissionProvider fetchPermission={fetchPermission(user)}>
      <QueryClientProvider client={queryClient}>
        <Suspense fallback={<LayoutSplashScreen />}>
          <BrowserRouter basename={basename}>
            <I18nProvider>
              <LayoutProvider>
                <Routes />
              </LayoutProvider>
            </I18nProvider>
          </BrowserRouter>
          <ToastContainer />
        </Suspense>
      </QueryClientProvider>
    </PermissionProvider>
  );
};

export { App };
